import { ClientJS } from "clientjs";
import * as AccountStore from "./account/AccountStore";

// @ts-ignore
window.ClientJS = ClientJS;
// @ts-ignore
window.CoerceToArrayBuffer = AccountStore.CoerceToArrayBuffer;
// @ts-ignore
window.CoerceToBase64Url = AccountStore.CoerceToBase64Url;
